<template>
  <v-app id="wgu-app" data-app :class="{ 'wgu-app': true, 'wgu-app-embedded': isEmbedded }">
    <v-main class="fill-height">
      <v-container class="fill-height login-page-container" fluid
        :style="{ backgroundImage: 'url(/static/img/login_bg.jpg)' }">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4" lg="3">
            <v-card class="elevation-4 login-card rounded-lg">
              <div class="px-6 py-12">
                <div class="text-center mb-6">
                  <h2 class="text-h5 font-weight-bold primary--text">公升大格</h2>
                  <div class="text-subtitle-1 grey--text mt-2">欢迎回来，请登录</div>
                </div>
                <v-form ref="form" v-model="valid" @submit.prevent="preLogin">
                  <v-text-field v-model="username" label="用户名" prepend-inner-icon="mdi-account" outlined dense
                    :rules="usernameRules" required color="primary"></v-text-field>
                  <v-text-field v-model="password" label="密码" placeholder="请输入密码"
                    :type="showPassword ? 'text' : 'password'" prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"
                    :rules="passwordRules" required outlined dense color="primary"></v-text-field>
                  <div class="mt-4">
                    <v-btn type="submit" color="primary" block large :disabled="!valid"
                      class="text-h6 font-weight-bold white--text">
                      登录
                    </v-btn>
                  </div>
                </v-form>
                <v-alert v-if="errorMessage" type="error" class="mt-4" dense text>{{ errorMessage }}</v-alert>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- Captcha Dialog -->
      <v-dialog v-model="showCaptcha" max-width="360px">
        <v-card class="pa-4 pt-8 d-flex flex-column align-center rounded-lg">
          <div class="text-h6 mb-4">安全验证</div>
          <div v-if="showCaptcha">
            <slide-verify :l="42" :r="10" :w="310" :h="155" :imgs="captchaImages" slider-text="向右滑动填充拼图"
              @success="onCaptchaSuccess" @fail="onCaptchaFail" @refresh="onCaptchaRefresh"></slide-verify>
          </div>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import { jwtDecode } from 'jwt-decode'; // Changed import statement

export default {
  data () {
    return {
      username: '',
      password: '',
      user: null,
      errorMessage: '',
      showPassword: false,
      showCaptcha: false, // Control captcha dialog visibility
      valid: false,
      captchaImages: [
        '/static/img/login_bg.jpg'
      ],
      usernameRules: [
        v => !!v || '用户名不能为空',
        v => (v && v.length >= 4 && v.length <= 20) || '用户名长度须在4-20字符之间'
      ],
      passwordRules: [
        v => !!v || '密码不能为空',
        v => (v && v.length >= 6 && v.length <= 18) || '密码长度须在6-18字符之间'
      ]
    }
  },
  mounted () {
    // Session restoration is now handled by router beforeEach guard
    // which properly fetches full user data from /users/me endpoint
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);
      console.log('Decoded JWT:', decoded);
      if (decoded.exp * 1000 <= Date.now()) {
        // Token expired, clean up
        localStorage.removeItem('jwt');
      }
    }
  },
  methods: {
    preLogin () {
      if (this.$refs.form.validate()) {
        this.errorMessage = '';
        this.showCaptcha = true;
      }
    },
    onCaptchaSuccess () {
      this.showCaptcha = false;
      this.login();
    },
    onCaptchaFail () {
      // Optional: Handle failure (e.g. show message)
    },
    onCaptchaRefresh () {
      // Optional: Handle refresh
    },
    async login () {
      // Remove validation check here since it's done in preLogin
      // if (!this.$refs.form.validate()) return;
      try {
        // Use store action for login
        await this.$store.dispatch('login', {
          username: this.username,
          password: this.password
        });

        // Fetch full user profile
        const user = await this.$store.dispatch('fetchUser');

        // Redirect based on role
        const redirectPath = this.$route.query.redirect || null;
        const role = user.role ? user.role.role_code : 'CLIENT';

        if (role === 'ADMIN') {
          this.$router.push(redirectPath || '/admin');
        } else {
          // Both INSURER and CLIENT go to main map/dashboard for now
          this.$router.push(redirectPath || '/');
        }

        this.$emit('login-success');
        this.$store.commit('clearSelectedLandPlots');
      } catch (error) {
        console.error('Login error:', error);
        if (error.response) {
          // ...existing error handling...
          this.errorMessage = '用户名或密码错误';
        } else {
          this.errorMessage = '登录请求失败，请重试';
        }
      }
    }

  }
}
</script>

<style scoped>
.fill-height {
  height: 100%;
}

.login-page-container {
  background-color: #f5f5f5;
  /* background-image is set inline to avoid webpack resolution issues */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* Dark overlay for better text readability if needed */
  position: relative;
}

.login-page-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  /* Semi-transparent overlay */
  z-index: 0;
}

/* Ensure content is above the overlay */
.login-page-container>.row {
  position: relative;
  z-index: 1;
}

.login-card {
  /* background-color: #036d36 !important; */
  /* Removing forced green background */
  background-color: rgba(255, 255, 255, 0.9) !important;
  /* Slightly transparent white for glassmorphism effect */
  backdrop-filter: blur(10px);
}

/* Dark mode adjustment */
.v-application.theme--dark .login-card {
  background-color: #1E1E1E !important;
}

/* Slide verify customization */
::v-deep .slide-verify {
  position: relative;
  width: 100% !important;
}

::v-deep .slide-verify-slider {
  margin-top: 15px;
  border: 1px solid #dcdfe6;
  background-color: #ffffff;
  color: #333333 !important;
  height: 40px;
  line-height: 40px;
}

::v-deep .slide-verify-slider-mask {
  background-color: #d1e9ff;
  border: 0 solid #1991fa;
}

::v-deep .slide-verify-slider-text {
  color: #333333 !important;
  opacity: 1 !important;
  font-size: 14px;
  font-weight: 500;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.3);
}

::v-deep .slide-verify-slider-mask-item {
  background-color: #1991fa;
  border: 0 solid #1991fa;
}

::v-deep .slide-verify-slider-mask-item-icon {
  background-color: #1991fa;
  color: #ffffff;
}
</style>
